import { red } from '@mui/material/colors';

const style = {
  redItem: {
    color: red[500],
  },
};

export default style;
